<template>
  <div 
    v-if="show" 
    class="toast-notification"
    :class="{ 
      'success': type === 'success', 
      'error': type === 'error',
      'info': type === 'info'
    }"
  >
    <div class="toast-content">
      <i v-if="type === 'success'" class="icon-success"></i>
      <i v-else-if="type === 'error'" class="icon-error"></i>
      <i v-else class="icon-info"></i>
      <span>{{ message }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ToastNotification',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'info',
      validator: (value) => ['success', 'error', 'info'].includes(value)
    }
  }
}
</script>

<style scoped>
.toast-notification {
  position: fixed;
  bottom: 20px;
  right: 20px;
  padding: 12px 20px;
  border-radius: 6px;
  background-color: white;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 10000;
  display: flex;
  align-items: center;
  animation: slideUp 0.3s ease forwards;
  max-width: 400px;
}

.toast-notification.success {
  border-left: 4px solid var(--success-color);
}

.toast-notification.error {
  border-left: 4px solid var(--danger-color);
}

.toast-notification.info {
  border-left: 4px solid var(--info-color);
}

.toast-content {
  display: flex;
  align-items: center;
  gap: 10px;
}

.toast-content i {
  font-size: 1.1rem;
}

.toast-content span {
  font-size: 0.9rem;
  color: var(--text-primary);
}

@keyframes slideUp {
  from {
    transform: translateY(20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}
</style> 